import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { component, DateType, property } from '../../../concepts/objects';
import { round } from '../../../platform/geom/Math';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { AdapterInfo, CreateAdapterInfo } from '../../canvas/AdapterInfo';
import { EditorSession } from '../../canvas/EditorSession';
import { AutoBringToFront } from '../../canvas/entities/AutoBringToFront';
import { Figure, Physical, TransformScope } from '../../canvas/entities/Physical';
import { RectangularPhysical } from '../../canvas/entities/RectangularPhysical';
import { Audited } from '../auditing/Audited';
import { AutoLayoutSubject } from '../autoLayout/AutoLayout';

const symbolMutate = defineCommand(
    'symbolMutate',
    null,
    (r, [id]: [string]) => {
        r.call(EditorSession).update(AdapterInfo, CreateAdapterInfo(id, 'field'));
    },
    [],
);

const propsDef = {
    name: 'Symbol',
    implements: [Physical, Audited, AutoBringToFront, AutoLayoutSubject],
    mutation: symbolMutate
};

const symbolTransformHints = Object.freeze({
    scaleX: false,
    scaleY: false,
    rotate: false,
    translate: true,
});

@component(propsDef)
export class Symbol extends RectangularPhysical implements Audited, AutoBringToFront {

    @property({ type: 'string' })
    public userId!: string;

    @property({ type: DateType })
    public created!: Date;

    public get boundary() {
        return true;
    }

    public queryTransformHints(_singular: boolean) {
        return symbolTransformHints;
    }

    public test(mpt: Point): boolean {

        for (const ch of this.children) {
            const ph = ch.as(Physical);
            if (ph && ph.test(mpt)) {
                return true;
            }
        }

        return false;
    }

    public applyTransformation(scope: TransformScope, from: Figure, to: Figure): this {
        // Figures are always model level, so we need to apply the inverse transform of the parent to localize it.
        const tlt = this.modelLocalTransform();
        from = tlt.apply(from);
        to = tlt.apply(to);

        // prev
        const pw = Point.vector(from[0], from[1]).length();
        const ph = Point.vector(from[1], from[2]).length();

        // Calcualte new center point
        const nc = Rect.fromPoints(to).center();

        this.x = round(nc.x - (pw / 2), 4);
        this.y = round(nc.y - (ph / 2), 4);
        this.r = round(0, 4);
        this.width = round(pw, 4);
        this.height = round(ph, 4);

        return this;
    }
}


